import { createSlice } from '@reduxjs/toolkit';
import { DashboardApi,RecentMember,ActiveMembersList,MemberinCountrys } from '../api/DashboardApi';

const initialState = {
  dashboardData: {},
  Recentmember:{},
activeMemberData:{},
memberinCountryData:{},
  loading: false,
  error: null,
};

export const DashboardSlice = createSlice({
  name: 'DashboardSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(DashboardApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DashboardApi.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
      
        state.loading = false;
      })
      .addCase(DashboardApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Something went wrong';
      });

      builder
      .addCase(RecentMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(RecentMember.fulfilled, (state, action) => {
        state.Recentmember = action.payload;
      
        state.loading = false;
      })
      .addCase(RecentMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Something went wrong';
      });

      builder
      .addCase(ActiveMembersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ActiveMembersList.fulfilled, (state, action) => {
        state.activeMemberData = action.payload;
      
        state.loading = false;
      })
      .addCase(ActiveMembersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Something went wrong';
      });



      builder
      .addCase(MemberinCountrys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MemberinCountrys.fulfilled, (state, action) => {
        state.memberinCountryData = action.payload;
      
        state.loading = false;
      })
      .addCase(MemberinCountrys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Something went wrong';
      });
  },
});

export default DashboardSlice.reducer;
